import { Skeleton } from '../ui/skeleton';

/** Dashboard skeleton - shows while stats are loading */
export const DashboardSkeleton = () => (
  <div className="space-y-6 animate-in fade-in duration-200">
    <div className="grid md:grid-cols-3 gap-6">
      {[1, 2, 3].map((i) => (
        <div key={i} className="rounded-xl border border-slate-200 p-6 space-y-3">
          <Skeleton className="h-4 w-24 bg-slate-200" />
          <div className="flex items-center gap-3">
            <Skeleton className="h-10 w-10 rounded-lg bg-slate-200" />
            <Skeleton className="h-8 w-16 bg-slate-200" />
          </div>
        </div>
      ))}
    </div>
    <div className="rounded-xl border border-slate-200 p-6 space-y-4">
      <Skeleton className="h-5 w-32 bg-slate-200" />
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="flex items-center gap-4 p-4 rounded-lg border border-slate-100">
          <Skeleton className="h-10 w-10 rounded-lg bg-slate-100" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-28 bg-slate-100" />
            <Skeleton className="h-3 w-48 bg-slate-100" />
          </div>
          <Skeleton className="h-6 w-16 rounded-full bg-slate-100" />
        </div>
      ))}
    </div>
  </div>
);

/** CMR/Fustbon history list skeleton */
export const ListSkeleton = ({ rows = 6 }) => (
  <div className="space-y-3 animate-in fade-in duration-200">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex items-center gap-4 p-4 rounded-lg border border-slate-200" style={{ animationDelay: `${i * 40}ms` }}>
        <Skeleton className="h-10 w-10 rounded-lg bg-slate-200 shrink-0" />
        <div className="flex-1 min-w-0 space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-28 bg-slate-200" />
            <Skeleton className="h-5 w-16 rounded-full bg-slate-100" />
          </div>
          <Skeleton className="h-3 w-48 bg-slate-100" />
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <Skeleton className="h-8 w-8 rounded bg-slate-100" />
          <Skeleton className="h-8 w-8 rounded bg-slate-100" />
        </div>
      </div>
    ))}
  </div>
);

/** Stat card skeleton for admin panel */
export const StatCardSkeleton = () => (
  <div className="rounded-xl border border-white/10 bg-[#0B1F3B] p-5 space-y-3">
    <div className="flex items-start justify-between">
      <div className="space-y-2">
        <Skeleton className="h-3 w-20 bg-white/5" />
        <Skeleton className="h-8 w-12 bg-white/10" />
      </div>
      <Skeleton className="h-10 w-10 rounded-lg bg-white/5" />
    </div>
  </div>
);

/** Page-level skeleton for Suspense fallback */
export const PageSkeleton = () => (
  <div className="min-h-screen bg-slate-50 p-6 animate-in fade-in duration-150">
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-7 w-40 bg-slate-200" />
          <Skeleton className="h-4 w-56 bg-slate-100" />
        </div>
        <Skeleton className="h-10 w-32 rounded-lg bg-slate-200" />
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-xl border border-slate-200 p-6 space-y-3">
            <Skeleton className="h-4 w-24 bg-slate-200" />
            <Skeleton className="h-8 w-16 bg-slate-200" />
          </div>
        ))}
      </div>
      <ListSkeleton rows={4} />
    </div>
  </div>
);
